import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import call from '../../../assets/image/phone-call.svg';
import email from '../../../assets/image/email.svg';
import arrowDown from '../../../assets/image/arrow_down_dark.svg';
import arrowUp from '../../../assets/image/arrow_up_dark.svg';
import { fetchPurchaseBillDetails } from '../../../services/purchase_bill';
import PageLoader from '../../../component/PageLoader';
import { getDate } from '../../../utils/dateUtils';
import SalesDrawer from '../../../component/SalesDrawer';

const BillDetailDrawer = ({ isOpen, onClose, id }) => {
	const navigate = useNavigate();
	const suburl = localStorage.getItem('suburl');
	const [details, setDetails] = useState({});
	const [isLoading, setLoading] = useState(false);
	const [isProductShow, setIsProductShow] = useState(true);
	const [isBillDetailShow, setIsBillDetailShow] = useState(true);
	const viewMore = () => {
		navigate(`/user/${suburl}/purchases-bills-details/${id}`);
	};
	async function getDrawerDetails() {
		try {
			setLoading(true);
			var data = await fetchPurchaseBillDetails(id);
			setDetails(data);
		} catch (e) {
			toast.error(e.message || 'Somenthing went wrong!');
		} finally {
			setLoading(false);
		}
	}
	useEffect(() => {
		if (id) {
			getDrawerDetails();
		}
	}, [id]);
	return (
		<SalesDrawer
			isOpen={isOpen}
			onClose={onClose}
			viewMore={viewMore}
			title={`Purchase Bill Details`}
		>
			<br />
			{isLoading ? (
				<PageLoader />
			) : (
				<div>
					<div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
						<div
							style={{ fontSize: '20px', fontWeight: '600', color: '#000', textAlign: 'center' }}
						>
							{details?.vendor?.vendor_name}
						</div>
						<div
							style={{
								padding: '10px 20px',
								fontSize: '14px',
								fontWeight: '400',
								color: '#000',
								textAlign: 'center',
							}}
						>
							{`${details?.vendor?.vendor_address?.street_1 || 'N|A'}, ${details?.vendor?.vendor_address?.city?.name || 'N/A'}`}
							<br />
							<span>{`${details?.vendor?.vendor_address?.state?.name || 'N/A'},${details?.vendor?.vendor_address?.country?.name || 'N/A'}-${details?.vendor?.vendor_address?.zip_code}`}</span>
						</div>
					</div>
					<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							flexDirection: details?.vendor?.email.length > 22 ? 'column' : 'row',
							padding: '10px 0px',
						}}
					>
						<div
							className="clickableButton"
							style={{
								width: details?.vendor?.email.length > 22 ? '100%' : '49%',
								marginBottom: details?.vendor?.email.length > 22 ? '10px' : '0px',
							}}
						>
							<img
								src={call}
								alt=""
								style={{ width: '14px', cursor: 'pointer' }}
								onClick={() => { }}
							/>
							<span style={{ marginLeft: '5px' }}>{details?.vendor?.phone_mobile}</span>
						</div>
						<div
							className="clickableButton"
							style={{ width: details?.vendor?.email.length > 22 ? '100%' : '49%' }}
						>
							<img
								src={email}
								alt=""
								style={{ width: '14px', cursor: 'pointer' }}
								onClick={() => { }}
							/>
							<span style={{ marginLeft: '5px' }}>{details?.vendor?.email}</span>
						</div>
					</div>
					<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							flexDirection: 'row',
							padding: '10px 0px',
						}}
					>
						<div className="AmountsBox">
							<div
								style={{
									fontSize: '16px',
									fontWeight: '600',
									color: '#000',
									textAlign: 'center',
								}}
							>
								{'Total Amount'}
							</div>
							<span style={{ marginLeft: '5px' }}>
								{`INR ${Number(details?.bill_amount).toFixed(2)}/-`}
							</span>
						</div>
						<div
							className="AmountsBox"
							style={{ width: '49%' }}
						>
							<div
								style={{ fontSize: '16px', fontWeight: '600', color: '#000', textAlign: 'center' }}
							>
								{'Balance Due'}
							</div>
							<span style={{ marginLeft: '5px' }}>
								{`INR ${Number(details?.due_amount).toFixed(2)}/-`}
							</span>
						</div>
					</div>
					<div
						className="invoiceBox"
						style={{ paddingBottom: isBillDetailShow ? '10px' : '0px' }}
					>
						<div
							className="d-flex justify-content-between"
							style={{
								backgroundColor: '#DADDEC',
								padding: '5px 10px',
								borderRadius: '4px 4px 0px 0px',
								cursor: 'pointer',
							}}
							onClick={() => setIsBillDetailShow(!isBillDetailShow)}
						>
							<div
								style={{
									fontSize: '15px',
									fontWeight: '600',
								}}
							>
								{'Purchase Bill Details'}
							</div>
							<img
								src={`${isBillDetailShow ? arrowUp : arrowDown}`}
								style={{
									cursor: 'pointer',
								}}
								onClick={() => setIsBillDetailShow(!isBillDetailShow)}
								alt=""
							/>
						</div>
						{isBillDetailShow && (
							<div>
								<div className="invoiceDataColumn">
									<div className="rowInvoiceData">{'Purchase Bill No.'}</div>
									<div className="rowInvoiceData">{details?.purchase_bill_number}</div>
								</div>
								<div className="invoiceDataColumn">
									<div className="rowInvoiceData">{'Bill No.'}</div>
									<div className="rowInvoiceData">{details?.bill_number}</div>
								</div>
								<div className="invoiceDataColumn">
									<div className="rowInvoiceData">{'Bill Date'}</div>
									<div className="rowInvoiceData">{getDate(details?.bill_date)}</div>
								</div>
								<div className="invoiceDataColumn">
									<div className="rowInvoiceData">{'Due Date'}</div>
									<div className="rowInvoiceData">{getDate(details?.due_date)}</div>
								</div>
								<div className="invoiceDataColumn">
									<div className="rowInvoiceData">{'Payment Terms'}</div>
									<div className="rowInvoiceData">
										{details?.vendor?.vendor_other_details?.payment_terms || 'N|A'}
									</div>
								</div>
								<div className="invoiceDataColumn">
									<div className="rowInvoiceData">{'Payment Method'}</div>
									<div className="rowInvoiceData">{details?.payment_method}</div>
								</div>
							</div>
						)}
					</div>
					<div className="invoiceBox">
						<div
							className="d-flex justify-content-between"
							style={{
								backgroundColor: '#DADDEC',
								padding: '5px 10px',
								borderRadius: '4px 4px 0px 0px',
								cursor: 'pointer',
							}}
							onClick={() => setIsProductShow(!isProductShow)}
						>
							<div
								style={{
									fontSize: '15px',
									fontWeight: '700',
								}}
							>
								{'Product Details'}
							</div>
							<img
								src={`${isProductShow ? arrowUp : arrowDown}`}
								style={{
									cursor: 'pointer',
								}}
								onClick={() => setIsProductShow(!isProductShow)}
								alt=""
							/>
						</div>
						{isProductShow && (
							<table
								style={{
									width: '100%',
									border: '0px',
									backgroundColor: '#fff !important',
									borderCollapse: 'collapse',
									textAlign: 'left',
								}}
							>
								<thead>
									<tr>
										<th
											style={{
												padding: '5px',
												fontSize: '15px',
												fontWeight: '500',
												textAlign: 'left',
												backgroundColor: '#EEEFF3',
											}}
										>
											Item Name
										</th>
										<th
											style={{
												padding: '5px',
												fontSize: '15px',
												fontWeight: '500',
												textAlign: 'left',
												backgroundColor: '#EEEFF3',
											}}
										>
											Quantity
										</th>
										<th
											style={{
												padding: '5px',
												fontSize: '15px',
												fontWeight: '500',
												textAlign: 'left',
												backgroundColor: '#EEEFF3',
											}}
										>
											Rate
										</th>
									</tr>
								</thead>
								<tbody>
									{details?.purchase_bill_products?.map((pb) => (
										<tr>
											<td
												style={{
													padding: '5px',
													textAlign: 'left',
													fontSize: '14px',
													fontWeight: '400',
													color: '#000',
													cursor: 'pointer',
													backgroundColor: '#F6F6F9',
												}}
											>
												{pb?.product?.product_name}
											</td>
											<td
												style={{
													padding: '5px',
													textAlign: 'left',
													fontSize: '14px',
													fontWeight: '400',
													color: '#000',
													backgroundColor: '#F6F6F9',
												}}
											>
												{`${pb?.quantity} ${pb?.product?.unit?.key || ''}`}
											</td>
											<td
												style={{
													padding: '5px',
													textAlign: 'left',
													fontSize: '14px',
													fontWeight: '400',
													color: '#000',
													backgroundColor: '#F6F6F9',
												}}
											>
												{Number(pb?.amount).toFixed(2)}
											</td>
										</tr>
									))}
								</tbody>
							</table>
						)}
					</div>
				</div>
			)}
		</SalesDrawer>
	);
};

export default BillDetailDrawer;
